import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import LoadingOverlay from "react-loading-overlay";
import { Layout } from "../../../components/Layout";
import "./style.css";
import "./Contact.scss";

import { CInput, CButton } from "@coreui/react";
import { withTranslation } from 'react-i18next';
import Spinner from "../../../components/Spinner";
import Swal from "sweetalert2";
import {post} from "../../../services/APIService";
import Config from "../../../services/Config";
import { Helmet } from 'react-helmet';


//Prod
//const TEST_SITE_KEY = "6LcQUvwnAAAAAJvrxuJOVJpWl3h_nLdHZxe5BCMp";
const TEST_SITE_KEY = "6LfCiQspAAAAAMU88iYs0a6Y4qKiVIYpb59xBSA9";

//local
//const TEST_SITE_KEY = "6LfjyLgfAAAAAE05En-w6n4JXJ9DekOm7DHCU261";

const ref = React.createRef();
const options = {
  orientation: "landscape",
};

const isMobile = (window.innerWidth <= 800)



class Calculate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      i_aracDegeri: 0,
      i_alternatifYatirimGetirisi: 0,
      i_kullanimKm: 0,
      i_aracDegerDususu: 0,
      i_kasko: 0,
      i_trafikSigorta: 0,
      i_digerSigortaGideri: 0,
      i_sigortaDisiGider: 0,
      i_aracGarantiKapsamDisi: 0,
      i_lastik: 0,
      i_priyodikBakim: 0,
      i_mtv: 0,
      i_kisLastigi: 0,
      i_beklenmeyenGiderler: 0,
      i_aracKiralamaBedeli: 0,
      o_aracYillikMaliyet: 0,
      o_aracDegerOrani: 0,
      o_aylikMaliyet: 0,
      o_donemSonuDegeri: 0,
      o_alternatifGetiriTutari: 0,
      o_kiralamaDonemSonuGeliri: 0,
      name: "",
      mobile: "",
      message: "",
      mail: "",
      title: ""
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidMount() {}

  handleChange = (value) => {
    console.log("Captcha value:", value);
    this.setState({ value });
    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
    console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  currencyToInt(currency) {
    var number = Number(currency.replace(/[^0-9.-]+/g, ""));
    return parseInt(number);
  }

  calculate() {
    let _i_aracDegeri = this.currencyToInt(this.state.i_aracDegeri);

    let aracYillikMaliyet =
      this.state.i_digerSigortaGideri +
      this.state.i_sigortaDisiGider +
      this.state.i_aracGarantiKapsamDisi +
      this.state.i_aracDegerDususu +
      this.state.i_kasko +
      this.state.i_trafikSigorta +
      this.state.i_lastik +
      this.state.i_priyodikBakim +
      this.state.i_mtv +
      this.state.i_kisLastigi +
      this.state.i_beklenmeyenGiderler;
    let aracDegerOrani = (aracYillikMaliyet * 100) / _i_aracDegeri;
    let donemSonuDegeri = _i_aracDegeri;
    let alternatifGetiriTutari =
      (_i_aracDegeri * this.state.i_alternatifYatirimGetirisi) / 100;
    let kiralamaDonemSonuGeliri = alternatifGetiriTutari + donemSonuDegeri;

    this.setState({ o_aracYillikMaliyet: Math.round(aracYillikMaliyet) });
    this.setState({ o_aracDegerOrani: Math.round(aracDegerOrani) });
    this.setState({ o_aylikMaliyet: Math.round(aracYillikMaliyet / 12) });
    this.setState({
      o_alternatifGetiriTutari: Math.round(
        (_i_aracDegeri * this.state.i_alternatifYatirimGetirisi) / 12
      ),
    });
    this.setState({ o_donemSonuDegeri: Math.round(donemSonuDegeri) });
    this.setState({
      o_alternatifGetiriTutari: Math.round(alternatifGetiriTutari),
    });
    this.setState({
      o_kiralamaDonemSonuGeliri: Math.round(kiralamaDonemSonuGeliri),
    });
  }
  
  sendMail = async () => {
    const data = {
      username: this.state.name,
      mobile: this.state.mobile,
      email: this.state.mail,
      messageText: this.state.message,
      request: this.state.message,
      messageText2: sessionStorage.getItem("lang") === "en" ? "OWNTIC – Your request is received\n" : "OWNTIC – Ihre Anfrage ist eingegangen\n",
      messageText4: sessionStorage.getItem("lang") === "en" ? ("Dear " + this.state.name) : ("Liebe/Lieber " + this.state.name),
      messageText3: sessionStorage.getItem("lang") !== "en" ? "Herzlich Willkommen bei OWNTIC,\n" +
          "\n" +
          "Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.\n" +
          "\n" +
          "Danke für Ihr Interesse." : "Welcome to OWNTIC,\n" +
          "\n" +
          "We will be in touch with you as soon as possible.\n" +
          "\n" +
        "Thanks for your interest. \n" + 
        "\n" +
          "Best regards,",
    };

    if (data.username == "" || data.mobile == "" || data.email == "" || data.messageText == "") {
        Swal.fire(this.props.t("error"), this.props.t("PopFillInRequired"), "error");

      return;
    }
    await post(Config.serverUrl + "SendMail/SendContactMail", data)
        .then((res) => {
            Swal.fire(this.props.t("success"), this.props.t("PopMailSent"), "success");
        })
        .catch((e) => {
            Swal.fire(this.props.t("error"), this.props.t("PopInternalError"), "error");
        });
  } 

    render() {
        const { t } = this.props;
    return (
      <LoadingOverlay
        active={this.state.isLoaderActive}
        spinner={<Spinner />}
      >
            <Layout>
                <Helmet>
                    <title>Owntic.com Adress & Phone</title>
                    <meta name="description" content="Please contact us for any questions you may have." />
                </Helmet>
          <section className="contact-container">
            <div className="contact-card">
              <section className="contact-header">
               <span>{t("contactBaslik")}</span>
              </section>

              <section className="contact-body">
                <div class="contact-form">
                  <div className="input-field">
                   <span className="contact-input-label">{t("contactAdSoyad")}</span>

                    <CInput value={this.state.name} onChange={(e) => this.setState({name: e.target.value})} type="string" />
                  </div>

                  <div className="input-field">
                   <span className="contact-input-label">{t("contactGsm")}</span>

                    <CInput value={this.state.mobile} onChange={(e) => this.setState({mobile: e.target.value})} type="number" />
                  </div>

                  <div className="input-field">
                   <span className="contact-input-label">{t("contactEposta")}</span>

                    <CInput value={this.state.mail} onChange={(e) => this.setState({mail: e.target.value})} type="email" />
                  </div>

                  <div className="input-field">
                   <span className="contact-input-label">{t("contactMesajiniz")}</span>

                    {/* <CFormTextarea aria-label="With textarea"></CFormTextarea> */}
                    <CInput value={this.state.message} onChange={(e) => this.setState({message: e.target.value})} type="string" style={{ height: "100px" }} />
                    {/* <textarea placeholder="Mesajınız"></textarea> */}
                  </div>

                  <div>
                    <ReCAPTCHA
                      style={{ display: "inline-block" }}
                      theme="light"
                      ref={this._reCaptchaRef}
                      sitekey={TEST_SITE_KEY}
                      onChange={this.handleChange}
                      asyncScriptOnLoad={this.asyncScriptOnLoad}
                    />
                  </div>

                  <div className="button-wrapper">
                   <CButton onClick={() => this.sendMail()} color="info" className={"general-button-all"}>{t("contactGonder")}</CButton>
                  </div>
                </div>

                <div className="map-container">
                  <div className="frame-wrapper">
                        <img src="Content/Images/contact-01.png" style={{ width: "100%" }} />
                  </div>
                </div>
              </section>

              <section className="contact-footer text-center">
                            {/*                <div className="footer-item">*/}
                            {/*<i className="fa fa-map-marked-alt"></i>*/}
                            {/*<span>USA</span>*/}
                            {/*</div>*/}

                <div className="footer-item">
                  <i className="fa fa-envelope"></i>
                  <span>info@owntic.com</span>
                </div>

                <div className="footer-item" style={{ }}>
                                {/*    <i className="fa fa-mobile-alt"></i> */}
                    <i className="fa fa-sharp fa-solid fa-phone"></i>
                                <span>+1 (518) 720-6055</span>
                </div>

                 <div className="footer-item" style={{ display: "none" }}>
                  <i className="fa fa-fax"></i>
                  <span>(+1) 178 338 97 67</span>
                </div>
{/*
                  <div className="footer-item" style={{  borderRight: "none" }}>
                  <i className="fab fa-whatsapp"></i>
                  <span>(+49) 152 59454972</span>
                </div>
*/}
              </section>
            </div>
          </section>
        </Layout>
      </LoadingOverlay>
    );
  }
}

export default withTranslation()(Calculate)
